import { QueryBuilder } from 'components/resources/triggers/QueryBuilder';
import { CreateButton } from 'components/utils/styled-components/FormStyle';
import { Component } from 'react';
import { Form } from 'reactstrap';
import { Header } from '../../utils/panels/Header';

interface ConditionBuilderProps {
  condition: string | null;
  conditionLogic: any;
  builderJsonTree: any;
  toggleModal: () => void;
  setCondition: Function;
}

interface ConditionBuilderState {
  condition: string | null;
  conditionLogic: any;
  builderJsonTree: any;
}

class ConditionBuilder extends Component<ConditionBuilderProps, ConditionBuilderState> {
  constructor(props: ConditionBuilderProps) {
    super(props);

    this.state = {
      condition: null,
      conditionLogic: undefined,
      builderJsonTree: null,
    };
  }

  componentDidMount() {
    this.setState({
      condition: this.props.condition,
      conditionLogic: this.props.conditionLogic,
      builderJsonTree: this.props.builderJsonTree,
    });
  }

  setBuilderCondition = (condition) => {
    this.setState({
      condition: condition,
    });
  };

  setConditionLogic = (e) => this.setState({ conditionLogic: e });

  setQueryValue = (e) => this.setState({ builderJsonTree: e });

  setChoiceMapping = (e) => this.setState({ choiceMapping: e } as Pick<ConditionBuilderState, any>);

  saveCondition = (e) => {
    e.preventDefault();
    e.stopPropagation();

    this.props.toggleModal();
    this.props.setCondition(
      this.state.condition,
      this.state.conditionLogic,
      this.state.builderJsonTree
    );
  };

  render() {
    const queryBuilderProps = {
      setCondition: this.setBuilderCondition,
      setConditionLogic: this.setConditionLogic,
      setQueryValue: this.setQueryValue,
      queryValue: this.state.builderJsonTree ? this.state.builderJsonTree : null,
      setChoiceMapping: this.setChoiceMapping,
    };
    return (
      <div className='mx-3 mt-[20px]'>
        <Form onSubmit={this.saveCondition}>
          <Header className='px-0' title='Condition Builder' toggleModal={this.props.toggleModal} />
          <QueryBuilder {...queryBuilderProps} />
          <CreateButton className='mt-2' type='submit' name='action'>
            {this.props.builderJsonTree ? 'Update' : 'Create'}
          </CreateButton>
        </Form>
      </div>
    );
  }
}

export default ConditionBuilder;
